module.exports = __webpack_public_path__ + "static/media/student-red.de1db69f.svg";